import React from "react";
import { Outlet } from "react-router-dom";

import { useUserContext } from "../context/User";
import Footer from "./Footer";
import Head from "./Head";
import UserPage from "./UserPage";
import UserToolbar from "./UserToolbar";

export default function Layout({ dark = false }) {
  const { user, logout } = useUserContext();

  return (
    <main
      className={`relative flex flex-grow flex-col bg-no-repeat ${
        dark ? "bg-[#0C0202]" : "bg-theme-white"
      }`}
    >
      <UserToolbar />
      <Head />
      <div className="flex flex-grow flex-col">
        <Outlet />
      </div>
      <UserPage />
      <Footer />
    </main>
  );
}
